import { TitlesFootnotesReadDto } from "./api/tlfItem/TitlesFootnotesReadDto";
import { TlfItemIndexReadDto } from "./api/tlfItem/TlfItemIndexReadDto";
import { TlfItemReadDto } from "./api/tlfItem/TlfItemReadDto";

/**
 * Converts a TlfItemReadDto or TitlesFootnotesReadDto to a TlfItemIndexReadDto.
 *
 * @param tlfItem - The TLF (Table, Listing, or Figure) item to convert to Index DTO
 * @returns TlfItemIndexReadDto
 */
export const toIndexDto = (
  tlfItem: TlfItemReadDto | TitlesFootnotesReadDto,
): TlfItemIndexReadDto => ({
  id: tlfItem.id,
  azsolId: tlfItem.azsolId,
  version: tlfItem.version,

  primaryHierarchyId: tlfItem.primaryHierarchyId,
  primaryHierarchyLevel: tlfItem.primaryHierarchyLevel,
  primaryHierarchyName: tlfItem.primaryHierarchyName,
  primaryHierarchyType: tlfItem.primaryHierarchyType,
  taPrefix: tlfItem.taPrefix,
  projectCode: tlfItem.projectCode,
  dNumber: tlfItem.dNumber,
  hierarchyLinks: tlfItem.hierarchyLinks,
  singles: tlfItem.singles,

  tocOrder: tlfItem.tocOrder,
  tocNumber: tlfItem.tocNumber,
  tocLabel: tlfItem.tocLabel,
  tocReleaseStatus: tlfItem.tocReleaseStatus,
  tocOriginTrafficLight: tlfItem.tocOriginTrafficLight,
  coreTrafficLight: tlfItem.coreTrafficLight,
  coreTrafficLightSwitch: tlfItem.coreTrafficLightSwitch,

  additionalInformation: tlfItem.additionalInformation,
  type: tlfItem.type,
  domain: tlfItem.domain,

  releaseDate: tlfItem.releaseDate,
  decommissionDate: tlfItem.decommissionDate,
  releaseStatus: tlfItem.releaseStatus,

  relationships: tlfItem.relationships,
  isBackupVersion: tlfItem.isBackupVersion,
});
